import React, { FC, ReactNode } from 'react';
import { Link as ChakraUiLink, Box } from '@chakra-ui/react';
import { LinkVariant } from './types';
import { withTooltip, Tooltip } from '../../hoc';
import { TextStyles } from '@everfi/design-system/dist/tsc/types';
import { Icon } from '../Icon';

export interface LinkProps {
  children?: ReactNode;
  href?: string;
  target?: string;
  variant?: LinkVariant | string;
  tooltip?: Tooltip;
  onClick?: () => void;
  onFocus?: () => void;
  onKeyDown?: () => void;
  textStyle?: TextStyles;
}

export const Link: FC<LinkProps> = React.forwardRef<HTMLLinkElement, LinkProps>((props, ref) => {
  const { children, textStyle, ...rest } = props;
  /**
   * DOM
   * */
  return (
    <ChakraUiLink
      // @ts-ignore NOTE: tech-debt
      ref={ref}
      data-object-type="core-link"
      textStyle={textStyle}
      {...rest}
      // aria-label={iconPosition === 'icon-only' && iconName ? iconName : undefined} // TODO - need to change the way the icon is passed to use the core icon component, aria-label can not be set in both CORE and SDK
    >
      {children}
    </ChakraUiLink>
  );
});

Link.displayName = 'Link';

export default withTooltip('CoreLink')(Link);
